import * as React from "react";
const SvgFiBrandsElementor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-elementor_svg__a)">
      <path
        fill="#151A2D"
        d="M12.503 0C5.6-.001.001 5.37 0 11.997S5.594 23.999 12.497 24 24.999 18.63 25 12.003V12C25 5.374 19.405.001 12.503 0M9.376 16.999H7.293v-10h2.083zm8.334 0h-6.25v-2h6.25zm0-4.001h-6.25v-2h6.25zm0-3.999h-6.25v-2h6.25z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-elementor_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsElementor;
